import {
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
  useCallback,
  useMemo,
} from "react";
import { useHistory, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import { Formik } from "formik";
import Swal from "sweetalert2";
import * as _ from "lodash";
import axios from "axios";
import "../../index.css";
import { NumericFormat } from "react-number-format";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  addCustomerList,
  setNewCustomer,
} from "../../redux/reducers/customerReducer";
import { addBankList } from "../../redux/reducers/bankReducer";

// components
import BillForCheckOut58 from "../../components/bill/BillForCheckOut58";
import BillForCheckOut80 from "../../components/bill/BillForCheckOut80";
import BillOfferPrice from "../../components/bill/BillOfferPrice";
import BillForCheckOutA4V3 from "../../components/bill/BillForCheckOutA4V3";
import { errorSwal, successSwal } from "../../helper/sweetalert";
import { base64ToBlob, convertCurrency } from "../../helper";
import CustomButton from "../../components/CustomButton";
import { LaoAddress } from "../../const/laoAddress";
import EmptyCart from "../../components/EmptyCart";
import CalculatorModal from "../sale/CalculatorModal";
import { numberFormat } from "../../helper";
import { APP_COLOR, LINEAR_GRADIENT_BG, USER_KEY, SHOP_SETTING_KEY } from "../../const";

// apollo
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CREATE_MANY_ORDER_WITH_ORDER_GROUP,
  CREATE_MANY_ORDER_WITH_ORDER_GROUP_INDEBTED,
  CREATE_MANY_ORDER_WITH_ORDER_GROUP_NOT_YET_PAID,
} from "../../apollo/order/mutation";
import { CREATE_MANY_OFFERPRICE_WITH_OFFERPRICE_GROUP } from "../../apollo/offerprice/mutation";
import {
  SALE_OFFER_PRICE,
  UPDATE_OFFERPRICE_GROUP,
} from "../../apollo/offerpricegroup/mutation";
import { CREATE_USER_CONFIRM } from "../../apollo/userconfirm/mutation";
import { GET_USER_CONFIRM } from "../../apollo/userconfirm/query";
import { GET_BANKS } from "../../apollo/bank/query";

// icon
import Add from "@mui/icons-material/Add";
import Close from "@mui/icons-material/Close";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

// bootrap
import {
  Row,
  Col,
  Modal,
  Table,
  Spinner,
  Card,
  Button,
  ButtonGroup,
} from "react-bootstrap";
import { Form, Tab, Tabs } from "react-bootstrap";
import { UPDATE_ORDER_GROUP } from "../../apollo/ordergroup/mutation";
import EmptyComponent from "../../components/EmptyComponent";
import BillIndebTed from "../../components/bill/BillIndebTed";
import AnimationLoading from "../../components/Animationloading";
import EmptyProducts from "../../components/EmptyProducts";
import useScanDetection from "use-scan-detection";
import { SCAN_PRODUCT } from "../../apollo/product/query";
import ComfirmModal from "../../components/ComfirmModal";
import { Input } from "@mui/material";
import { MdAutorenew, MdCheck } from "react-icons/md";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import DragDrop from "../../components/reorder/DragDrop";
import useWindowDimensions from "../../helper/windowDimensions";
import BillOfferPriceV4 from "../../components/bill/BillOfferPriceV4";

function CartsOfferPrice({
  containerRef,
  selectedPayCurrency,
  originProducts,
  setOriginProducts,
  cartDatas,
  setCartDatas,
  activeCart,
  setActiveCart,
  updateOrder,
  onClearOrder,
  fetchProductData,
  printer,
  gencodeordergroup,
  _loadGenCode,
  saleEditdata,
  addOrder,
  shopData
}) {
  const dispatch = useDispatch();

  const Location = useLocation();
  const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const staffname = JSON.parse(localStorage.getItem(USER_KEY));
  const history = useHistory();
  let componentRef = useRef();
  let billIndebTedRef = useRef();

  //data for redux
  const { customerList } = useSelector((state) => state.customer);
  const { bankList } = useSelector((state) => state.bank);
  const { height, width } = useWindowDimensions()

  // console.log("customerList===>", bankList);

  const [showAddcustommer, setShowAddCustommer] = useState(false);
  const [showaddcustomerIndebTed, setShowAddCustomerIndebTed] = useState(false);
  const [customerId, setCustomerId] = useState();
  const [customername, setCustommerName] = useState();
  const [customerLastName, setCustommerLastName] = useState();
  const [phonenumber, setPhoneNumber] = useState();
  const [village, setVillage] = useState();
  const [district, setDistrict] = useState();
  const [province, setProvince] = useState();
  const [userconfirmName, setUserConfirmName] = useState();
  const [userconfirmPhone, setUserConfirmPhone] = useState();
  const [showAddCustomerBill, setShowAddCusTomerBill] = useState(false);
  const [userconfirm, setUserConfirm] = useState();
  const [selectuserconfirm, setSelectUserConfirm] = useState();
  const [userconfirmId, setUserConfirmId] = useState();
  const [showAddress, setShowAdddress] = useState(false);
  const [phonenumberAdd, setPhoneNumberAdd] = useState();
  const [selectProvince, setSelectProvince] = useState();
  const [selectDistrict, setSelectDistrict] = useState();
  const [selectvillage, setSelectVillage] = useState();
  const [bankaccount, setBankAccount] = useState();
  const [showDetailSaleModal, setShowDetailSaleModal] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalPricePay, setTotalPricePay] = useState(0);
  const [change, setChange] = useState(0);
  const [receivedMoney, setReceivedMoney] = useState(0);
  const [activeTab, setActiveTab] = useState("ເງິນສົດ");
  const [offerPrice, setOffePrice] = useState();
  const [selectedPrice, setSelectedPrice] = useState();
  const [widthBill80, setWidthBill80] = useState(0);
  const [widthBill58, setWidthBill58] = useState(0);
  const [notYetPaid, setNotYetPaid] = useState(false);
  const [searchcustomer, setSearchCustomer] = useState("");
  const [state, setState] = useState(saleEditdata);
  const [editdata, setEditdata] = useState(Location.state);
  const [codeBill, setCodeBill] = useState(null);

  const [reorder, setReorder] = useState([]);

  useEffect(() => {
    if (cartDatas) {
      setReorder(cartDatas.flatMap((cart) => cart.data.orders));
    }
  }, [cartDatas]);

  const [showConfirmRemove, setShowConfirmRemove] = useState(false);
  const [openEditPrice, setOpenEditPrice] = useState(false);

  const handleShowConfirmProduct = () => {
    setShowConfirmRemove(true);
  };

  const handleCloseRemoveProduct = () => {
    setShowConfirmRemove(false);
    setOpenEditPrice(false);
  };

  const handleConfirmRemoveCart = () => {
    setShowConfirmRemove(false);
    setOpenEditPrice(true);
  };

  // ======== Query And Mutation ==========

  const [getuserConfirm, { data: getuserConfirmData }] = useLazyQuery(
    GET_USER_CONFIRM,
    { fetchPolicy: "cache-and-network" }
  );
  const [getBank, { data: getbankData, loading: bankloadding }] = useLazyQuery(
    GET_BANKS,
    { fetchPolicy: "cache-and-network" }
  );
  const [getProductFromBarcode] = useLazyQuery(SCAN_PRODUCT);

  const [
    createManyOfferPriceWithOfferPriceGroup,
    { loading: createOfferPriceLoading },
  ] = useMutation(CREATE_MANY_OFFERPRICE_WITH_OFFERPRICE_GROUP);
  const [createManyOrderWithOrderGroup, { loading: createOrderLoading }] =
    useMutation(CREATE_MANY_ORDER_WITH_ORDER_GROUP);
  
  const [updateOfferPriceGroup, { loading: offerpriceGrouploading }] =
    useMutation(UPDATE_OFFERPRICE_GROUP);
  const [updateOrdergroup, { loading: ordergroupLoadding }] =
    useMutation(UPDATE_ORDER_GROUP);
  const [createUserConfirm, { loading: loadingCreate }] =
    useMutation(CREATE_USER_CONFIRM);
  const [saleOfferPrice, { loading: saleOfferPriceLoading }] =
    useMutation(SALE_OFFER_PRICE);

  const [loadingPrintBill, setLoadingPrintBill] = useState(false);
  const [loadingSaleBill, setLoadingSaleBill] = useState(false);

  // ==========> useEffect <==========

  useEffect(() => {
    if (customerList?.length === 0) {
      getuserConfirm({
        variables: {
          where: {
            shop: shopId,
            isDeleted: false,
          },
        },
      });
    }

    if (bankList?.length === 0) {
      getBank({
        variables: {
          // limit: 50,
          orderBy: "createdAt_DESC",
          where: {
            shop: shopId,
            isDeleted: false,
          },
        },
      });
    }
  }, [shopId]);

  useEffect(() => {
    _filter();
  }, [searchcustomer]);

  useEffect(() => {
    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
    if (!selectedCart) return;
    setTotalAmount(selectedCart?.data?.orderGroup?.amount ?? 0);
    setTotalPricePay(selectedCart?.data?.orderGroup?.sumPrice ?? 0);
    _loadGenCode();
  }, [activeCart, JSON.stringify(cartDatas)]);

  useEffect(() => {
    if (editdata?.isEdited) {
      setCustommerName(editdata?.state?.customerName);
      setPhoneNumber(editdata?.state?.phone);
    }
  }, [editdata?.isEdited]);

  useEffect(() => {
    if (getbankData?.banks?.data) {
      dispatch(addBankList(getbankData?.banks?.data));
      setBankAccount(getbankData?.banks?.data);
    }

    if (getuserConfirmData?.userconfirms?.data) {
      dispatch(addCustomerList(getuserConfirmData?.userconfirms?.data));
    }
  }, [getbankData?.banks?.data, getuserConfirmData?.userconfirms?.data]);

  useEffect(() => {
    if (selectedPrice !== "ALL") changeAllPrice();
  }, [selectedPrice]);

  useEffect(() => {
    if (selectuserconfirm) {
      setCustomerId(selectuserconfirm?.id);
      setCustommerName(selectuserconfirm?.name);
      setCustommerLastName(selectuserconfirm?.lastname);
      setPhoneNumber(selectuserconfirm?.phone);
      setUserConfirmId(selectuserconfirm?.id);
      setVillage(selectuserconfirm?.address?.village);
      setDistrict(selectuserconfirm?.address?.district);
      setProvince(selectuserconfirm?.address?.province);
    }
  }, [selectuserconfirm]);

  const handleSelect = (label) => {
    setActiveCart(label);
  };

  const handleDiscountTypeChange = (isFixed) => {
    const updatedCarts = cartDatas.map((cart) => {
      if (cart.label === activeCart) {
        const orderGroup = { ...cart.data.orderGroup, discountType: isFixed };
        return { ...cart, data: { ...cart.data, orderGroup } };
      }
      return cart;
    });
    setCartDatas(updatedCarts);
  };

  const handleDiscountValueChange = (value) => {
    const updatedCarts = cartDatas.map((cart) => {
      if (cart.label === activeCart) {
        const orderGroup = { ...cart.data.orderGroup };
        if (orderGroup.discountType) {
          orderGroup.discountManual = value || 0;
          orderGroup.discount = 0;
        } else {
          orderGroup.discount = value || 0;
          orderGroup.discountManual = 0;
        }
        return { ...cart, data: { ...cart.data, orderGroup } };
      }
      return cart;
    });
    setCartDatas(updatedCarts);
  };
 
  // clear cart function -------->
  const handleClearCartDatas = () => {
    fetchProductData();
    setShowDetailSaleModal(false);
    handleRemoveCart({ label: activeCart, isRemove: true });
    setActiveTab("ເງິນສົດ");
    setChange(0);
    setReceivedMoney("0");
    setCustommerName();
    setPhoneNumber();
    setCustommerLastName();
    setVillage();
    setDistrict();
    setSelectUserConfirm();
    setProvince();

    if (cartDatas?.length <= 1) {
      const newCart = {
        id: 1,
        label: "Bill 1",
        data: {
          orders: [],
          orderGroup: {
            amount: 0,
            totalPrice: 0,
            receivedMoney: 0,
            change: 0,
            sumPriceBaht: 0,
            sumPriceUsd: 0,
            currency: "LAK",
            shop: shopId,
            payment: "CASH",
            discount: 0,
            discountManual: 0,
            discountType: false,
            discountAmountApplied: 0,
          },
        },
      };
      setCartDatas([newCart]);
    }

    setLoadingPrintBill(false);
    setLoadingSaleBill(false);
  };

  const handleOpentOfferprice = () => {
    setShowAddCustomerIndebTed(true);
  };

  const handleOfferprices = () => {
    setShowAddCustommer(true);
    if (getuserConfirmData?.userconfirms?.data) {
      setUserConfirm(getuserConfirmData?.userconfirms?.data);
    }
  };


  const _createUser = async (values) => {
    if (!values.name) {
      errorSwal("ກະລຸນາເພີ່ມຂໍ້ມູນ...");
      return;
    }
    try {
      if (loadingCreate) return;
      const createNewUser = await createUserConfirm({
        variables: {
          data: {
            ...values,
            phone: phonenumberAdd.toString(),
            address: {
              village: selectvillage,
              district: selectDistrict,
              province: selectProvince,
            },
          },
        },
      });

      // console.log("creatCREe----->", createNewUser)
      if (createNewUser?.data?.createUserConfirm?.id !== null) {
        let data = createNewUser?.data?.createUserConfirm;

        // console.log("data create customer --->", data);
        dispatch(
          setNewCustomer({
            id: data?.id,
            name: data?.name,
            lastname: data?.lastname,
            gender: data?.gender,
            phone: data?.phone,
            address: {
              village: data?.address?.village,
              district: data?.address?.district,
              province: data?.address?.province,
            },
          })
        );

        setShowAddCusTomerBill(false);
        // successSwal("ເພີ່ມສຳເລັດ");
        setPhoneNumberAdd();
      }

    } catch (err) {
      errorSwal("ລາຍຊື່ລູກຄ້ານີ້ມີຢູ່ແລ້ວ");
    }
  };


  const handleAddCart = async () => {
    const shopId = (await JSON.parse(localStorage.getItem("SHOP_DATA")))?.id;

    if (cartDatas?.length >= 3) return;

    const lastCartId = cartDatas[cartDatas?.length - 1]?.id || 0;
    const number = parseInt(gencodeordergroup - 1) + lastCartId + 1;
    const _genBarCode = number.toString().padStart(4, "0");

    const newCart = {
      id: lastCartId + 1,
      label: `Bill ${lastCartId + 1}`,
      data: {
        orders: [],
        orderGroup: {
          // code: _genBarCode,
          amount: 0,
          totalPrice: 0,
          receivedMoney: 0,
          change: 0,
          sumPriceBaht: 0,
          sumPriceUsd: 0,
          currency: "LAK",
          shop: shopId,
          payment: "CASH",
          discount: 0,
          discountManual: 0,
          discountType: false,
          discountAmountApplied: 0,
        },
      },
    };

    setCartDatas([...cartDatas, newCart]);
    setActiveCart(newCart?.label);
  };

  // ລ້າງສິນຄ້າໃນກະຕ່າອອກ
  const handleRemoveCart = async ({ label, isRemove }) => {
    if (!isRemove) return;

    const shopId = (await JSON.parse(localStorage.getItem("SHOP_DATA")))?.id;

    const orderData = _.find(cartDatas, { label });
    const { orders } = orderData?.data;

    const updatedOriginData = originProducts.map((originProduct) => {
      const matchingData = orders.find(
        (order) => order.product === originProduct.id
      );
      return matchingData
        ? {
          ...originProduct,
          amount: matchingData.amount + originProduct.amount,
        }
        : originProduct;
    });

    setOriginProducts(updatedOriginData);

    if (cartDatas?.length === 1) {
      setActiveCart("Bill 1");
      return setCartDatas([
        {
          id: 1,
          label: "Bill 1",
          data: {
            orders: [],
            orderGroup: {
              amount: 0,
              totalPrice: 0,
              receivedMoney: 0,
              change: 0,
              sumPriceBaht: 0,
              sumPriceUsd: 0,
              currency: "LAK",
              shop: shopId,
              payment: "CASH",
            },
          },
        },
      ]);
    }

    const _newCartDatas = cartDatas.filter((cart) => cart.label !== label);
    setCartDatas(_newCartDatas);
    if (activeCart === label) {
      setActiveCart(_newCartDatas[0].label);
    } else {
      setActiveCart(activeCart);
    }
  };

  const onCreateManyOrderWithOrderGroup = async () => {
    try {
      if (editdata?.isEdited) {
        return _saleOfferPrice();
      }

      const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);

      if (!selectedCart) {
        return;
      }

      const { orders, orderGroup } = selectedCart?.data;
      const staffFirstName =
        staffname?.data?.firstName || staffname?.data?.nickname;

      const _updatedOfferPriceGroup = {
        ...orderGroup,
        shop: shopId,
        customerName: customername,
        customerLastName: customerLastName,
        village: village,
        district: district,
        province: province,
        phone: phonenumber,
        staff: staffFirstName,
        staffLastname: staffname?.data?.lastName,
        payment: activeTab === "ເງິນໂອນ" ? "TRANSFER" : "CASH",
        change: parseFloat(change),
        currency: selectedPayCurrency,
        receivedMoney: parseFloat(receivedMoney),
      };

      const updatedOfferprices = orders.map((order) => {
        const { totalAmount, brand, priceOptions, product, category, ...rest } =
          order;
        return { ...rest, stock: order?.product };
      });

      const _newOfferpriceDataWithOfferpriceGroup = {
        ...selectedCart?.data,
        orders: updatedOfferprices,
        orderGroup: _updatedOfferPriceGroup,
      };

      // return;
      await createManyOrderWithOrderGroup({
        variables: { 
          data: {
            ..._newOfferpriceDataWithOfferpriceGroup,
            orderGroup: {
              ..._updatedOfferPriceGroup,
              discount: orderGroup?.discount,
              discountManual: orderGroup?.discountManual,
              discountType: orderGroup?.discountType,
              discountAmountApplied: orderGroup?.discountAmountApplied,
              taxes: orderGroup?.taxes,
            }
          } 
        },
      });

      handleClearCartDatas();

      return successSwal("ສໍາເລັດການຂາຍ");
    } catch (err) {
      console.log(err?.message);
      errorSwal("ມີຂໍ້ຜິດພາດ");
      return;
    }
  };


  // print ------------->
  const handleCreateOrderForPrintUsb = () => {
    onCreateManyOrderWithOrderGroup();
  };

  // ຮັບບິນ
  const createOrderPrintBill = () => {
    setLoadingPrintBill(true);
    onCreateManyOrderWithOrderGroup();
    onPrintBill();
  };

  // ບໍ່ຮັບບິນ
  const createOrderNotPrintBill = () => {
    setLoadingSaleBill(true);
    onCreateManyOrderWithOrderGroup();
  };

  //TODO: Update offerprices  when Edit
  const _updateofferprice = async () => {
    try {
      if (offerpriceGrouploading) return;

      // TODO: Find cart data
      const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
      if (!selectedCart) return;

      // TODO: Get orders and order group
      const { orders, orderGroup } = selectedCart?.data;

      const _newOfferPrices = reorder.map((order) => {
        const { totalAmount, brand, priceOptions, product, category, ...rest } =
          order;
        return { 
          ...rest, 
          stock: order?.product ?? order?.stock,
          survivalId: order?.survivalId?.survivalNumber,
        };
      });

      await updateOfferPriceGroup({
        variables: {
          where: {
            id: editdata?.state?.id,
          },
          data: {
            amount: orderGroup?.amount,
            sumPrice: orderGroup?.sumPrice,
            totalPrice: orderGroup?.totalPrice,
            sumPriceBaht: orderGroup?.sumPriceBaht,
            sumPriceUsd: orderGroup?.sumPriceUsd,
            currency: orderGroup?.currency ?? "LAK",
            discount: orderGroup?.discount,
            discountManual: orderGroup?.discountManual,
            discountType: orderGroup?.discountType,
            discountAmountApplied: orderGroup?.discountAmountApplied,
            taxes: orderGroup?.taxes,
            customerName: customername,
            customerLastName: customerLastName,
            phone: phonenumber,
            village: village,
            district: district,
            province: province,
            staff: staffname?.data?.firstName || staffname?.data?.nickname,
            staffLastname: staffname?.data?.lastName,
            userConfirm: selectuserconfirm?.id,
            change: parseFloat(change),
            receivedMoney: parseFloat(receivedMoney),
            offerprices: _newOfferPrices,
          },
        },
      });

      await history.push("/history_offerprices/limit/50/page/1");
      successSwal("ເເກ້ໄຂບິນສະເໜີລາຄາສຳເລັດ");
    } catch (err) {
      errorSwal("ຜິດພາດກະລຸນາລອງໃຫມ່ອີກຄັ້ງ");
      // console.log("error creating todo:", err);
    }
  };

  //TODO: Update orders  when Edit
  const _updateorders = async () => {
    try {
      if (ordergroupLoadding) return;

      // TODO: Find cart data
      const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
      if (!selectedCart) return;

      // TODO: Get orders and order group
      const { orders, orderGroup } = selectedCart?.data;

      const _newOrders = orders.map((order) => {
        const { totalAmount, brand, priceOptions, product, category, ...rest } =
          order;
        return { ...rest, stock: order?.stock ?? order?.product };
      });

      // console.log("edit bill----->", _newOrders)

      await updateOrdergroup({
        variables: {
          where: {
            id: editdata?.state?.id,
          },
          data: {
            amount: orderGroup?.amount,
            sumPrice: orderGroup?.sumPrice,
            totalPrice: orderGroup?.totalPrice,
            sumPriceBaht: orderGroup?.sumPriceBaht,
            sumPriceUsd: orderGroup?.sumPriceUsd,
            currency: orderGroup?.currency ?? "LAK",
            discount: orderGroup?.discount,
            discountManual: orderGroup?.discountManual,
            discountType: orderGroup?.discountType,
            discountAmountApplied: orderGroup?.discountAmountApplied,
            taxes: orderGroup?.taxes,
            customerName: customername,
            phone: phonenumber,
            customerLastName: customerLastName,
            village: village,
            district: district,
            province: province,
            orders: _newOrders,
          },
        },
      });

      history.push("/salehistory/limit/50/page/1");

      successSwal("ເເກ້ໄຂອໍເດີສຳເລັດ");
    } catch (err) {
      errorSwal("ຜິດພາດກະລຸນາລອງໃຫມ່ອີກຄັ້ງ");
    }
  };

  //TODO: Update orders  when Edit
  const _updateordersIndebted = async () => {
    try {
      if (ordergroupLoadding) return;

      // TODO: Find cart data
      const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
      if (!selectedCart) return;

      // TODO: Get orders and order group
      const { orders, orderGroup } = selectedCart?.data;

      const _newOrders = orders.map((order) => {
        const { totalAmount, brand, priceOptions, product, category, ...rest } =
          order;
        return { ...rest, stock: order?.product };
      });

      await updateOrdergroup({
        variables: {
          where: {
            id: editdata?.state?.id,
          },
          data: {
            amount: orderGroup?.amount,
            sumPrice: orderGroup?.sumPrice,
            totalPrice: orderGroup?.totalPrice,
            sumPriceBaht: orderGroup?.sumPriceBaht,
            sumPriceUsd: orderGroup?.sumPriceUsd,
            currency: orderGroup?.currency ?? "LAK",
            discount: orderGroup?.discount,
            discountManual: orderGroup?.discountManual,
            discountType: orderGroup?.discountType,
            discountAmountApplied: orderGroup?.discountAmountApplied,
            taxes: orderGroup?.taxes,
            customerName: customername,
            phone: phonenumber,
            customerLastName: customerLastName,
            village: village,
            district: district,
            province: province,
            orders: _newOrders,
          },
        },
      });
      // history.goBack(-1);
      history.push("/historyindebted");
      successSwal("ເເກ້ໄຂອໍເດີສຳເລັດ");
    } catch (err) {
      errorSwal("ຜິດພາດກະລຸນາລອງໃຫມ່ອີກຄັ້ງ");
      // console.log("error creating todo:", err);
    }
  };

  const _saleOfferPrice = async () => {
    if (saleOfferPriceLoading) return;
    const shopId = await JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    // TODO: Find cart data
    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
    if (!selectedCart) return;

    // TODO: Get orders and order group
    const { orders, orderGroup } = selectedCart?.data;

    const _newOfferPrices = orders.map((order) => {
      const { totalAmount, brand, priceOptions, category, ...rest } = order;
      return rest;
    });

    const _offerPrices = _newOfferPrices?.map((offerPrice) => {
      return {
        amount: offerPrice?.amount ?? 0,
        price: offerPrice?.price,
        totalPrice: offerPrice?.totalPrice,
        shop: orderGroup?.shop,
        stock: offerPrice?.product,
        productName: offerPrice?.productName,
        currency: offerPrice?.currency ? offerPrice?.currency : "LAK",
      };
    });

    await saleOfferPrice({
      variables: {
        where: {
          id: editdata?.state?.id,
        },
        data: {
          amount: orderGroup?.amount,
          totalPrice: orderGroup?.totalPrice,
          receivedMoney: 0,
          change: 0,
          sumPrice: orderGroup?.sumPrice,
          sumPriceBaht: orderGroup?.sumPriceBaht,
          sumPriceUsd: orderGroup?.sumPriceUsd,
          currency: selectedPayCurrency
            ? selectedPayCurrency
            : orderGroup?.currency ?? "LAK",
          discount: orderGroup?.discount,
          discountManual: orderGroup?.discountManual,
          discountType: orderGroup?.discountType,
          discountAmountApplied: orderGroup?.discountAmountApplied,
          taxes: orderGroup?.taxes,
          shop: orderGroup?.shop,
          payment: orderGroup?.payment ?? "CASH",
          offerprices: _offerPrices,
        },
      },
    });

    setShowDetailSaleModal(false);
    // TODO: Clear bill
    handleRemoveCart({ label: activeCart, isRemove: true });
    setActiveTab("ເງິນສົດ");
    setChange(0);
    setReceivedMoney("0");

    history.replace();
    if (cartDatas?.length <= 1) {
      setCartDatas([
        {
          id: 1,
          label: "Bill 1",
          data: {
            orders: [],
            orderGroup: {
              amount: 0,
              totalPrice: 0,
              receivedMoney: 0,
              change: 0,
              sumPriceBaht: 0,
              sumPriceUsd: 0,
              currency: "LAK",
              shop: shopId,
              payment: "CASH",
            },
          },
        },
      ]);
    }
    history.goBack(-1);
    return successSwal("ສໍາເລັດການຂາຍ");
  };

  const onCreateManyOfferPriceWithOfferPriceGroup = async () => {
    try {
      const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);

      if (!selectedCart) return;

      const { orders, orderGroup } = selectedCart.data;

      const _updatedOfferPriceGroup = {
        ...orderGroup,
        shop: shopId,
        currency: selectedPayCurrency,
        customerName: customername,
        customerLastName,
        staff: staffname?.data?.firstName || staffname?.data?.nickname,
        staffLastname: staffname?.data?.lastName,
        phone: phonenumber,
        userConfirm: selectuserconfirm?.id,
        village,
        district,
        province,
        change: parseFloat(change),
        receivedMoney: parseFloat(receivedMoney),
      };

      setOffePrice({
        offerprices: orders.map(
          ({ totalAmount, priceOptions, brand, category, ...rest }) => rest
        ),
        offerPriceGroup: _updatedOfferPriceGroup,
      });

      const newResult = await createManyOfferPriceWithOfferPriceGroup({
        variables: {
          data: {
            offerprices: orders.map(
              (order) => {
                const {
                  totalAmount,
                  brand,
                  priceOptions,
                  product,
                  category,
                  ...rest
                } = order;
                return { 
                  ...rest, 
                  stock: order?.product,
                  survival: order?.survivalId?.survivalNumber,
                  survivalId: order?.survivalId?.id
                };
              }
            ),
            offerPriceGroup: {
               ..._updatedOfferPriceGroup,
               discount: orderGroup?.discount,
               discountManual: orderGroup?.discountManual,
               discountType: orderGroup?.discountType,
               discountAmountApplied: orderGroup?.discountAmountApplied,
               taxes: orderGroup?.taxes,
            },
          },
        },
      });

      if (newResult) {
        setCodeBill(newResult?.data?.createManyofferpricesWithofferpriceGroup);
        setShowDetailSaleModal(false);
        handleRemoveCart({ label: activeCart, isRemove: true });
        setActiveTab("ເງິນສົດ");
        setChange(0);
        setReceivedMoney("0");
        setShowAddCustommer(false);
      }


      if (cartDatas.length <= 1) {
        setCartDatas([
          {
            id: 1,
            label: "Bill 1",
            data: {
              orders: [],
              orderGroup: {
                amount: 0,
                totalPrice: 0,
                receivedMoney: 0,
                change: 0,
                sumPriceBaht: 0,
                sumPriceUsd: 0,
                currency: "LAK",
                shop: shopId,
                payment: "CASH",
              },
            },
          },
        ]);
        setShowAddCustommer(false);
        setSelectUserConfirm();
        setCustommerName();
        setPhoneNumber();
        setCustommerLastName();
        setVillage();
        setDistrict();
        setProvince();
      }
    } catch (err) {
      console.log(err?.message);
      errorSwal("ມີຂໍ້ຜິດພາດ");
    }
  };

  const getPageSize = () => {
    return `@page { 
             size: 210mm  297mm
          !important; }`;

    // return `@page { size: 3508px  2480px !important; }`;
  };

  // ==========> Fuction Prin Bill <==========
  let bill80Ref = useRef(null);
  let bill58Ref = useRef(null);
  useLayoutEffect(() => {
    setWidthBill80(bill80Ref.current.offsetWidth);
    setWidthBill58(bill58Ref.current.offsetWidth);
  }, [bill80Ref, bill58Ref]);

  const onPrintBill = async () => {
    try {
      const printerBillData = printer.find((e) => e?.status === true);

      // console.log("printer----->", printer);
      // console.log("printerBillData----->", printerBillData);
      // console.log("widthBill80--->", widthBill80);

      const dataImageForPrint = await html2canvas(
        printerBillData?.width === "80mm"
          ? bill80Ref.current
          : bill58Ref.current,
        {
          useCORS: true,
          scrollX: 10,
          scrollY: printerBillData?.width === "80mm" ? 2 : 0,
          scale:
            printerBillData?.width === "80mm"
              ? 560 / widthBill80
              : 350 / widthBill58,
        }
      );


      const urlByType = {
        ETHERNET: "ethernet",
        BLUETOOTH: "bluetooth",
        USB: "usb",
      };
      const urlForPrinter = `http://localhost:9150/${urlByType[printerBillData?.type]
        }/image`;

      const _file = await base64ToBlob(dataImageForPrint.toDataURL());
      const bodyFormData = new FormData();
      bodyFormData.append("ip", printerBillData?.ip);
      bodyFormData.append("port", "9100");
      bodyFormData.append("image", _file);
      bodyFormData.append("beep1", 1);
      bodyFormData.append("beep2", 9);

      await axios.post(urlForPrinter, bodyFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const toastConfig = {
        icon: "success",
        title: "ປິນສຳເລັດ",
        showConfirmButton: false,
        timer: 1500,
      };
      await Swal.fire(toastConfig);
    } catch (err) {
      console.log(err);
      await Swal.fire({
        icon: "error",
        title: "ປິນບໍ່ສຳເລັດ",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  // Check cart has selected

  const changeAllPrice = () => {
    const calculateTotalPrice = (order, newPrice) => {
      return order.amount * newPrice;
    };

    const getNewPrice = (order) => {
      const selectedPriceOption = order.priceOptions[selectedPrice];
      return selectedPriceOption?.price > 0 ||
        !_.isEmpty(selectedPriceOption?.price)
        ? selectedPriceOption?.price
        : order.price;
    };

    const calculateTotalPriceForCurrency = (order, newPrice) => {
      switch (order.currency) {
        case "LAK":
        case "ກີບ":
        case "BAHT":
        case "ບາດ":
        case "USD":
        case "ໂດລາ":
          return calculateTotalPrice(order, newPrice);
        // Add more cases for other currencies if needed
        default:
          return calculateTotalPrice(order, newPrice);
      }
    };

    const updateOrderPrices = (cart) => {
      return cart.data.orders.map((order) => {
        const newPrice = getNewPrice(order);
        const totalPrice = calculateTotalPriceForCurrency(order, newPrice);
        return { ...order, price: newPrice, totalPrice };
      });
    };

    const updateCartData = (cart) => {
      if (cart.label === activeCart) {
        const { orderGroup } = cart.data;
        return {
          ...cart,
          data: {
            orderGroup,
            orders: updateOrderPrices(cart),
          },
        };
      }
      return cart;
    };

    const updatedCartDatas = cartDatas?.map(updateCartData);

    setCartDatas(updatedCartDatas);
  };

  const _filter = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
      };

      // TODO: check if search text is not empty

      if (searchcustomer !== "") {
        _where = {
          ..._where,
          name: searchcustomer,
        };
      }

      // TODO: Get all product

      await getuserConfirm({
        variables: {
          orderBy: "createdAt_DESC",
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  // select product to cart
  const onSelectProduct = useCallback(
    (product) => {
      // console.log("====", { product });
      if (product?.amount <= 0) {
        errorSwal(`ສິນຄ້າ  ${product?.name} ໝົດສະຕອັກ`);
        return;
      }

      if (cartDatas?.length <= 0) {
        errorSwal("ກະລຸນາເພີ່ມໃບບີນ");
        return;
      }

      //ລວມອໍເດີທັງໝົດໄວ້
      const checkOrder = cartDatas?.flatMap((item) => item?.data?.orders) || [];

      // filter by product id scan
      const filteredOrders = checkOrder.filter(
        (order) => order.product === product.id
      );

      // sum amount by product id scan
      const sumTotal = filteredOrders.reduce(
        (total, order) => total + order.amount,
        0
      );


      const _check = checkedProductSelected(product);

      if (!_check) {
        addOrder({ product, productPrice: 0 });
      } else {
        updateOrder({
          product,
          productId: product?.id,
          isAdded: true,
          changeValue: 0,
        });
      }
    },
    [cartDatas, errorSwal, addOrder, updateOrder]
  );

  const getScanProduct = useCallback(
    async (barCode) => {
      if (!barCode) return;

      try {
        const { data } = await getProductFromBarcode({
          variables: {
            where: {
              _id: barCode,
              shop: shopId,
              isDeleted: false
            },
          },
        });

        const result = data?.stocksByBarcode;
        if (!result) return;

        const { type, product, productVariant } = result;

        if (type === "VARIANT" && productVariant) {
          // Variant → ใช้ราคา/จำนวนจาก productVariant, ชื่อ/หมวดหมู่/แบรนด์จาก product (parent)
          const attributes = (productVariant?.attributeValues || [])
            .map((attr) => {
              const name = attr?.attribute?.name || "";
              const value = attr?.value || "";
              return name ? `${name}${value ? `: ${value}` : ""}` : value;
            })
            .filter(Boolean)
            .join(", ");

          const productName = `${productVariant?.product?.name ?? product?.name ?? "-"}`;
          const variantName = attributes ? `${productName} (${attributes})` : productName;

          const normalizedVariant = {
            id: productVariant?.id,
            name: variantName,
            amount: productVariant?.amount ?? 0,
            originAmount: productVariant?.originAmount,
            originPrice: productVariant?.originPrice,
            price: productVariant?.price,
            currency: productVariant?.currency,
            commissionPlatforms:
              productVariant?.commissionPlatforms ||
              product?.commissionPlatforms ||
              [],
            productVariant: productVariant?.id,
            stock: product?._id,
            priceOptions: [],
            brand: product?.brand,
            category: product?.category,
            unit: product?.unit,
            hasVariant: false,
          };

          onSelectProduct(normalizedVariant);
        } else if (type === "PRODUCT" && product) {
          // Product ธรรมดา → map _id → id
          const normalizedProduct = { ...product, id: product?._id };
          onSelectProduct(normalizedProduct);
        }
      } catch (error) {
        console.error(error);
        // Handle error, e.g., show an error message
      }
    },
    [getProductFromBarcode, onSelectProduct, shopId]
  );

  const checkedProductSelected = (product) => {
    let _check = false;

    const cartData = _.find(cartDatas, { label: activeCart });
    cartData?.data?.orders?.map((productId) => {
      if (product?.id === productId?.product) _check = true;
    });
    return _check;
  };

  const handleEditPriceProduct = (e, index) => {
    let _converPrice = e?.target?.value.toString().replace(",", "");
    let _price = parseInt(_converPrice);

    const getCartData = cartDatas.filter((item) => item?.label === activeCart);
    let newOrder = [...cartDatas];
    let updatePriceOrder = getCartData[0].data;
    updatePriceOrder.orders[index].price = _price;
    updatePriceOrder.orders[index].totalPrice =
      updatePriceOrder.orders[index].amount * _price;

    setCartDatas(newOrder);
  };

  // get reorder item in cart

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const newItems = Array.from(reorder);
    const [reorderedItem] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, reorderedItem);

    setReorder(newItems);
    setCartDatas([
      {
        data: { orderGroup: cartDatas[0].data.orderGroup, orders: newItems },
        id: 1,
        label: "Bill 1",
      },
    ]);
  };

  return (
    <>
      <div style={{ width: width > 700 ? "70%" : "100%", marginLeft: width > 700 ? "10px" : 0, height: "90vh" }}>
        <Tabs
          activeKey={activeCart}
          style={{
            background: "#FFFFFF",
            border: "1px solid transparent",
            borderBottom: "1px solid transparent",
          }}
          onSelect={(e) => handleSelect(e)}
        >
          {cartDatas.map((cart, cIndex) => {
            return (
              <Tab
                style={{ borderBottom: "none" }}
                key={cart + cIndex}
                eventKey={cart.label}
              >
                <div
                  style={{
                    height: "90vh",
                    backgroundColor: "#FFFFFF",
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    padding: width > 700 ? 10 : 0,
                  }}
                >
                  <div
                    className="sale-cart-list-main"
                    style={{
                      height: "auto",
                    }}
                    ref={containerRef}
                  >
                    <DragDrop
                      handleOnDragEnd={handleOnDragEnd}
                      setCartDatas={setCartDatas}
                      updateOrder={updateOrder}
                      reorder={reorder}
                      onRemoveItem={onClearOrder}
                      cartDatas={cartDatas}
                      activeCart={activeCart}
                      shopData={shopData}
                    />

                  </div>
                  <hr />
                  <div className="sale-cart-total-amout">
                    <div className="sale-cart-total">
                      <div
                        style={{
                          color: "#222E3C",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        ເປັນເງິນ:
                      </div>
                      <div className="sale-cart-total-money">
                        <span style={{ fontWeight: "bold", fontSize: 18 }}>
                          {numberFormat(
                            cart?.data?.orderGroup?.totalPrice ?? 0
                          )}{" "}
                          ₭
                        </span>
                        <span style={{ fontWeight: "bold", fontSize: 18 }}>
                          {numberFormat(
                            cart?.data?.orderGroup?.sumPriceBaht ?? 0
                          )}{" "}
                          ฿
                        </span>
                        <span style={{ fontWeight: "bold", fontSize: 18 }}>
                          {numberFormat(
                            cart?.data?.orderGroup?.sumPriceUsd ?? 0
                          )}{" "}
                          $
                        </span>
                      </div>
                    </div>
                    {/* Discount UI */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
                        <div style={{ fontWeight: 'bold', fontSize: 16 }}>ສ່ວນຫຼຸດ ({cart?.data?.orderGroup?.discountType ? "LAK" : "%"}):</div>
                        <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                            <Form.Select 
                              size="sm" 
                              style={{ width: 90 }}
                              value={cart?.data?.orderGroup?.discountType ? "FIXED" : "PERCENT"}
                              onChange={(e) => handleDiscountTypeChange(e.target.value === "FIXED")}
                            >
                                <option value="PERCENT">%</option>
                                <option value="FIXED">LAK</option>
                            </Form.Select>
                            <NumericFormat
                              customInput={Form.Control}
                              size="sm"
                              style={{ width: 110, textAlign: 'right' }}
                              placeholder="0"
                              value={cart?.data?.orderGroup?.discountType ? cart?.data?.orderGroup?.discountManual : cart?.data?.orderGroup?.discount}
                              onValueChange={(values) => handleDiscountValueChange(values.floatValue)}
                              thousandSeparator={true}
                            />
                        </div>
                    </div>
                    { (cart?.data?.orderGroup?.discountAmountApplied > 0) && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                          <div style={{ fontSize: 13, color: 'red' }}>ມູນຄ່າສ່ວນຫຼຸດ:</div>
                          <div style={{ fontSize: 13, color: 'red' }}>-{numberFormat(cart?.data?.orderGroup?.discountAmountApplied)} ₭</div>
                      </div>
                    )}
                    { (cart?.data?.orderGroup?.taxes?.taxStatus) && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
                          <div style={{ fontSize: 13 }}>ອາກອນ({cart?.data?.orderGroup?.taxes?.tax}{cart?.data?.orderGroup?.taxes?.taxType === "PERCENT" ? "%" : "₭"}){cart?.data?.orderGroup?.taxes?.isVatIncluded ? " (ລວມ)" : ""}:</div>
                          <div style={{ fontSize: 13 }}>{cart?.data?.orderGroup?.taxes?.isVatIncluded ? "" : "+"}{numberFormat(cart?.data?.orderGroup?.taxes?.taxAmount)} ₭</div>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          color: "#222E3C",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        ເງິນລວມທັງໝົດ:{" "}
                      </span>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "20px",
                          color: "#3C169B",
                        }}
                      >
                        {numberFormat(cart?.data?.orderGroup?.sumPrice ?? 0)}{" "}
                        {cart?.orderGroup?.currency ??
                          convertCurrency(selectedPayCurrency)}
                      </span>
                    </div>
                    <div style={{ height: "17px" }}></div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 10,
                        marginTop: 20,
                      }}
                    >

                      <CustomButton
                        width="100%"
                        title={
                          editdata?.isEdited ? "ຢືນຢັນແກ້ໄຂ" : "ອອກບິນສະເໜີ"
                        }
                        padding={".75em"}
                        borderRadius="5px"
                        background={LINEAR_GRADIENT_BG}
                        color="#fff"
                        icon={<MdCheck sx={{ fontSize: 20 }} />}
                        onClick={async () => {
                          const selectedCart = cartDatas?.find(
                            (cart) => cart.label === activeCart
                          );
                          if (selectedCart?.data?.orders?.length <= 0)
                            return toast.info(
                              `ກະລຸນາເລືອກສິນຄ້າເຂົ້າກະຕ່າກ່ອນ!`,
                              {
                                position: "top-right",
                                autoClose: 700,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                              }
                            );
                          handleOfferprices();
                        }}
                      />
                    </div>

                  </div>
                </div>
              </Tab>
            );
          })}

        </Tabs>

        <Modal
          show={showAddcustommer}
          centered
          onHide={() => setShowAddCustommer(false)}
          size="lg"
        >
          <Formik
            enableReinitialize={true}
            initialValues={{
              customerName: customername,
              phone: phonenumber,
              customerLastName: customerLastName,
              village: village,
              district: district,
              province: province,
              shop: shopId,
            }}
            onSubmit={(values, { setSubmitting }) => {
              if (editdata?.isFromSale === true) _updateorders();
              if (editdata?.indebted === true) _updateordersIndebted();
              if (editdata?.isFromSale === false) _updateofferprice();
              if (!editdata?.isEdited)
                onCreateManyOfferPriceWithOfferPriceGroup(values);
              setCustommerName("");
              setPhoneNumber("");
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <>
                <Modal.Body style={{ height: "550px", padding: 20 }}>
                  {ordergroupLoadding ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <AnimationLoading />
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          padding: "5px",
                          fontSize: "24px",
                          fontWeight: "700",
                        }}
                      >
                        ເລືອກຊື່ລູກຄ້າ
                      </div>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "20px",
                          gap: 20,
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <Form.Control
                            type="text"
                            placeholder="ຄົ້ນຫາຊື່ ຫຼື ເບີໂທ..."
                            onChange={(e) => {
                              setSearchCustomer(e.target.value);
                            }}
                            value={searchcustomer}
                          />
                        </div>
                        <div
                          style={{
                            width: "30%",
                            display: "flex",
                            justifyContent: "end",
                          }}
                        >
                          <CustomButton
                            height={40}
                            borderRadius={8}
                            title={"ເພິ່ມ"}
                            onClick={() => setShowAddCusTomerBill(true)}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          height: "400px",
                          overflow: "auto",
                          marginTop: "1em",
                        }}
                      >
                        {customerList?.length > 0 ? (
                          <Table hover>
                            <thead>
                              <tr>
                                <th>ລຳດັບ</th>
                                <th>ຊື່ລູກຄ້າ</th>
                                <th>ເບີໂທ</th>
                                <th>ບ້ານ</th>
                                <th>ເມືອງ</th>
                                <th>ເເຂວງ</th>
                              </tr>
                            </thead>
                            <tbody>
                              {customerList?.map((u, index) => (
                                <tr
                                  key={"userconfirm1" + index}
                                  style={{
                                    // background:
                                    // selectuserconfirm?.id === u?.id
                                    //   ? "aqua"
                                    //   : "",
                                    cursor: "pointer",
                                    color:
                                      selectuserconfirm?.id === u?.id
                                        ? "green"
                                        : "",
                                  }}
                                  onClick={() => {
                                    setSelectUserConfirm(u);
                                  }}
                                >
                                  <td>{index + 1}</td>
                                  <td>{u?.name}</td>
                                  <td>{u?.phone}</td>
                                  <td>{u?.address?.village}</td>
                                  <td>{u?.address?.district}</td>
                                  <td>{u?.address?.province}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        ) : (
                          "Empty Customer"
                        )}
                      </div>
                    </>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: editdata?.isEdited
                        ? "space-between"
                        : "center",
                      width: "100%",
                    }}
                  >
                    {editdata?.isEdited ? (
                      <div
                        style={{
                          display: "flex",
                          fontWeight: "bold",
                          padding: "2px",
                          alignItems: "center",
                          color: "#3C169B",
                        }}
                      >
                        <div>
                          <span>ຊື່ລູກຄ້າ : {values.customerName}</span>&emsp;
                          <span>ເບີໂທ : {values.phone}</span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="d-flex justify-content-center gap-8">
                      {editdata?.isEdited ? (
                        <CustomButton
                          width={200}
                          height={60}
                          borderRadius={4}
                          background="transparent"
                          color="#3C169B"
                          border="1px solid #3C169B "
                          fontweight={400}
                          title={"ຍົກເລີກ"}
                          onClick={() => setShowAddCustommer(false)}
                        />
                      ) : (
                        <CustomButton
                          width={200}
                          height={60}
                          borderRadius={4}
                          background="transparent"
                          color="#3C169B"
                          border="1px solid #3C169B "
                          fontweight={400}
                          title={"ຍົກເລີກ"}
                          onClick={() => {
                            setCustommerName();
                            setPhoneNumber();
                            setCustommerLastName();
                            setVillage();
                            setDistrict();
                            setProvince();
                            setSelectUserConfirm();
                            setShowAddCustommer(false);
                          }}
                        />
                      )}
                      &emsp;
                      {editdata?.isEditedSale === true || editdata?.isEdited ? (
                        <CustomButton
                          width={200}
                          height={60}
                          background="#1F3A60"
                          borderRadius={4}
                          title={"OK"}
                          onClick={() => handleSubmit()}
                        />
                      ) : (
                        <div onClick={async () => await handleSubmit()}>
                          <ReactToPrint
                            pageStyle={getPageSize}
                            trigger={() => (
                              <CustomButton
                                width={200}
                                height={60}
                                background="#1F3A60"
                                borderRadius={4}
                                title={"OK"}
                              />
                            )}
                            content={() =>
                              values.customerName &&
                              values.phone &&
                              componentRef.current
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </Modal.Footer>
              </>
            )}
          </Formik>
        </Modal>

        {/* Bill 80mm */}
        <div style={{ display: "none" }}>
          <div style={{ width: "80mm" }} ref={bill80Ref}>
            <BillForCheckOut80
              showDetailSaleModal={showDetailSaleModal}
              receivedMoney={receivedMoney}
              cartDatas={cartDatas}
              activeCart={activeCart}
              selectedPayCurrency={selectedPayCurrency}
              gencodeordergroup={gencodeordergroup}
              customername={customername}
              phonenumber={phonenumber}
              userconfirmName={userconfirmName}
              userconfirmPhone={userconfirmPhone}
              bankaccount={bankaccount}
              customerLastName={customerLastName}
              village={village}
              district={district}
              province={province}
              notYetPaid={notYetPaid}
            />
          </div>
        </div>

        {/* Bill 50mm */}
        <div style={{ display: "none" }}>
          <div style={{ width: "58mm" }} ref={bill58Ref}>
            <BillForCheckOut58
              showDetailSaleModal={showDetailSaleModal}
              receivedMoney={receivedMoney}
              cartDatas={cartDatas}
              activeCart={activeCart}
            />
          </div>
        </div>
      </div>

      {/* ฺBill Offerpirce */}

      <div style={{ display: "none" }}>
        <div ref={componentRef}>
          {shopId === "674532cf47f983007f44748d" ? (
            <BillForCheckOutA4V3
              showDetailSaleModal={showDetailSaleModal}
              receivedMoney={receivedMoney}
              cartDatas={cartDatas}
              activeCart={activeCart}
              selectedPayCurrency={selectedPayCurrency}
              gencodeordergroup={gencodeordergroup}
              customername={customername}
              phonenumber={phonenumber}
              userconfirmName={userconfirmName}
              userconfirmPhone={userconfirmPhone}
              bankaccount={bankaccount}
              customerLastName={customerLastName}
              village={village}
              district={district}
              province={province}
              notYetPaid={notYetPaid}
              shopData={shopData}
            />
          ) : (
            <BillOfferPriceV4
              showDetailSaleModal={showDetailSaleModal}
              receivedMoney={receivedMoney}
              cartDatas={cartDatas}
              activeCart={activeCart}
              offerPrice={offerPrice}
              codeBill={codeBill}
              customername={customername}
              customerLastName={customerLastName}
              phonenumber={phonenumber}
              village={village}
              district={district}
              province={province}
            />
          )}
        </div>
      </div>

      {/* Modal Add Customer */}
      <Modal
        show={showAddCustomerBill}
        centered
        onHide={() => setShowAddCusTomerBill(false)}
        size="lg"
      >
        <Formik
          initialValues={{
            name: "",
            lastname: "",
            gender: "male",
            phone: "",
            address: {
              village: "",
              province: "",
              district: "",
            },
            shop: shopId,
          }}
          onSubmit={(values, { setSubmitting }) => {
            _createUser(values);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <Modal.Body style={{ padding: "5em" }}>
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#3C169B",
                  }}
                >
                  ເພີ່ມລູກຄ້າໃໝ່
                </div>
                <div className="p-3">
                  <Form>
                    <div className="d-flex justify-content-between align-items-center gap-4">
                      <Form.Group
                        className="mb-3 w-100"
                        controlId="formGroupEmail"
                      >
                        <Form.Label>ຊື່</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.name}
                          placeholder="ປ້ອນຊື່..."
                        />
                      </Form.Group>
                      <Form.Group
                        className="mb-3 w-100"
                        controlId="formGroupEmail"
                      >
                        <Form.Label>ນາມສະກຸນ</Form.Label>
                        <Form.Control
                          type="text"
                          name="lastname"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.lastname}
                          placeholder="ປ້ອນນາມສະກຸນ..."
                        />
                      </Form.Group>
                    </div>
                    <Row>
                      <Col>
                        <Form.Group className="mb-3" controlId="formGroupEmail">
                          <Form.Label>ເພດ</Form.Label>
                          <Form.Select
                            defaultValue="Choose..."
                            name="gender"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.gender}
                            aria-label="Default select example"
                          >
                            <option>--ເລືອກ--</option>
                            <option value="male">ຊາຍ</option>
                            <option value="female">ຍິງ</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col>

                        <Form.Group className="mb-3" controlId="formGroupPassword">
                          <Form.Label>ເບີໂທລູກຄ້າ</Form.Label>
                          <Form.Control
                            type="number"
                            name="phone"
                            onChange={(e) => setPhoneNumberAdd(e?.target.value)}
                            onBlur={handleBlur}
                            value={phonenumberAdd}
                            placeholder="+856 020 XXXX XXXX..."
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <div
                      // onClick={() => setShowAdddress(!showAddress)}
                      style={{
                        width: "100%",
                        height: "40px",
                        borderRadius: "4px",
                        display: "flex",
                        color: "#333",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "15px",
                      }}
                    >
                      ເພີ່ມຂໍ້ມູນທີ່ຢູ່ຂອງລູກຄ້າ
                    </div>

                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formGroupPassword"
                        >
                          <Form.Label>ແຂວງ</Form.Label>

                          <Form.Select
                            name="address.province"
                            onChange={(e) => {
                              setSelectProvince(e.target.value);
                            }}
                            onBlur={handleBlur}
                            value={selectProvince}
                            aria-label="Default select example"
                          >
                            <option value="">--ເລືອກ--</option>
                            {LaoAddress.map((p, index) => (
                              <option
                                key={"province" + index}
                                value={p?.province_name}
                              >
                                {p?.province_name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formGroupPassword"
                        >
                          <Form.Label>ເມືອງ</Form.Label>

                          <Form.Select
                            name="address.district"
                            disabled={!selectProvince}
                            onChange={(e) => {
                              setSelectDistrict(e.target.value);
                            }}
                            onBlur={handleBlur}
                            value={selectDistrict}
                            aria-label="Default select example"
                          >
                            <option value="">--ເລືອກ--</option>
                            {selectProvince &&
                              LaoAddress.filter(
                                (f) => f.province_name === selectProvince
                              )[0].district_list.map((p, index) => (
                                <option
                                  key={"district" + index}
                                  value={p?.district}
                                >
                                  {p?.district}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3" controlId="formGroupPassword">
                      <Form.Label>ບ້ານ</Form.Label>
                      <Form.Control
                        type="text"
                        name="address.village"
                        onChange={(e) => {
                          setSelectVillage(e.target.value);
                        }}
                        onBlur={handleBlur}
                        value={selectvillage}
                        placeholder="ປ້ອນຊື່ບ້ານ..."
                      />
                    </Form.Group>
                  </Form>
                </div>
              </Modal.Body>
              <Modal.Footer style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div>
                    <CustomButton
                      width={200}
                      height={42}
                      borderRadius={4}
                      background="transparent"
                      color="#3C169B"
                      border="1px solid #3C169B "
                      fontweight={400}
                      title={"ຍົກເລີກ"}
                      onClick={() => {
                        setSelectDistrict();
                        setSelectProvince();
                        setSelectVillage();
                        setVillage();
                        setDistrict();
                        setProvince();
                        setCustommerLastName();
                        setShowAdddress(false);
                        setShowAddCusTomerBill(false);
                      }}
                    />
                  </div>
                  &emsp;
                  <div>
                    <CustomButton
                      width={200}
                      height={42}
                      background="#1F3A60"
                      borderRadius={4}
                      title={loadingCreate ? <Spinner /> : "ບັນທຶກ"}
                      onClick={() => handleSubmit()}
                    />
                  </div>
                </div>
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>

      {/* modal comfirm edit price in cart */}

      <ComfirmModal
        showConfirmModal={showConfirmRemove}
        handleCancel={handleCloseRemoveProduct}
        handleConfirm={handleConfirmRemoveCart}
        title="ແຈ້ງເຕືອນ"
        text="ຕ້ອງການແກ້ໄຂ ສິນຄ້າສະເຫນີລາຄາ ບໍ?"
      />
    </>
  );
}
export default CartsOfferPrice;
